export const SET_HRMS13X_INDEX_DISP = 'SET_HRMS13X_INDEX_DISP'
export const GET_HRMS13X_INDEX_DISP = 'GET_HRMS13X_INDEX_DISP'
export const SET_HRMS13X_DETAIL_DISP = 'SET_HRMS13X_DETAIL_DISP'
export const GET_HRMS13X_DETAIL_DISP = 'GET_HRMS13X_DETAIL_DISP'
export const SET_HRMS13X_COLUMNS = 'SET_HRMS13X_COLUMNS'
export const GET_HRMS13X_COLUMNS = 'GET_HRMS13X_COLUMNS'
export const SET_HRMS13X_LABELS = 'SET_HRMS13X_LABELS'
export const GET_HRMS13X_LABELS = 'GET_HRMS13X_LABELS'
export const RECEIVED_HRMS13X_COLUMNS_LABELS = 'RECEIVED_HRMS13X_COLUMNS_LABELS'
export const SET_HRMS13X_INDEX = 'SET_HRMS13X_INDEX'
export const GET_HRMS13X_INDEX = 'GET_HRMS13X_INDEX'
export const SET_HRMS13X_INDEX_SELECTED = 'SET_HRMS13X_INDEX_SELECTED'
export const GET_HRMS13X_INDEX_SELECTED = 'GET_HRMS13X_INDEX_SELECTED'
export const RECEIVED_HRMS13X_INDEX = 'RECEIVED_HRMS13X_INDEX'
export const SET_HRMS13X_DETAIL = 'SET_HRMS13X_DETAIL'
export const GET_HRMS13X_DETAIL = 'GET_HRMS13X_DETAIL'
export const RECEIVED_HRMS13X_DETAIL = 'RECEIVED_HRMS13X_DETAIL'
export const TOGGLE_HRMS13X_PAGE = 'TOGGLE_HRMS13X_PAGE'
export const RECEIVED_HRMS13X_LISTFIELDS = 'RECEIVED_HRMS13X_LISTFIELDS'
export const SET_HRMS13X_LISTFIELDS = 'SET_HRMS13X_LISTFIELDS'
export const GET_HRMS13X_LISTFIELDS = 'GET_HRMS13X_LISTFIELDS'




// WEBPACK FOOTER //
// ./src/store/modules/hrms13x/mutation-types.js